import React from 'react';
import './App.css';
import {Accordion, AccordionDetails, AccordionSummary, Container, CssBaseline, Divider, Link, Paper, Typography} from '@material-ui/core';
import avatar from './avatar.jpg';
import email from './email.png';
import scut from './scut.png'
import wechat from './wechat.jpg'
import ant from './ant.jpg'
import updetr from './paper/up-detr.png'
import unimoco from './paper/unimoco.png'
import da from './paper/da.png'
import nl2sql from './paper/nl2sql.png'
import zero_shot from './paper/zero-shot.png'
import mps from './paper/mps.png'
// import qrcode from './paper/qrcode.png'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Entry,PaperEntry} from './components/entry'
class App extends React.Component{
  
  render() {
    const avator = (
      <Paper className="paper">
        <img alt="avatar" src={avatar} className="avatar"/>
        <div className="line-pattern padding2">
          <Typography variant='h3'>
            Zhigang Dai
          </Typography> 
          <Typography variant='h6'>
            South China University of China
          </Typography> 
          <Typography variant='h6'>
            Master student
          </Typography> 
          <div className="email">
            <img alt="email" src={email} className="email-img"/>
          </div> 
          <Typography variant='h6'>
            <Link href="https://github.com/dddzg" className="link">  Github  
            </Link>
            <span className="space">•</span> 
            <Link href="https://twitter.com/g80XRxiYWrDvK8p" className="link">
                Twitter  
            </Link>
            <span className="space">•</span> 
            <Link href="https://scholar.google.com/citations?user=mDksL9sAAAAJ" className="link">
                Google Scholar  
            </Link>
          </Typography>
        </div>
      </Paper>
    );

    const education = (        
      <Accordion
        defaultExpanded={true}
        >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='h4'>Education</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Entry 
            image={{alt:"scut",src:scut}} 
            title="Master at South China University of China" 
            subtitle="Sept. , 2019 - present" 
            content={
              <div>
                <div>Software Engineering</div>
                Advisor:<Link href="http://www2.scut.edu.cn/sse/2018/0614/c16789a270666/page.htm"> Junying Chen</Link>
              </div>}
          />
          <Divider variant="middle" />
          <Entry 
            image={{alt:"scut",src:scut}} 
            title="Bachelor at South China University of China" 
            subtitle="Sept. , 2015 - Jun. , 2019" 
            content={
              <div>
                <div>Software Engineering (Excellent Engineer Program)</div>
                <div>Excellent Graduated Thesis</div>
              </div>}
          />
        </AccordionDetails>
      </Accordion>);

    const experience = (        
      <Accordion
        defaultExpanded={true}
        >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='h4'>Experience</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <Entry 
          image={{alt:"wechat",src:wechat}} 
          title="Intern at Tencent, WeChat AI" 
          subtitle="Apr. , 2020 - present" 
          content={
            <div>
              <div>Computer vision engineer: unsupervised learning, object detection, QRCode</div>
              Mentor:<Link href="https://scholar.google.com/citations?user=wceVXfgAAAAJ"> Bolun Cai</Link>
            </div>}
        />
        <Divider variant="middle" />
        <Entry 
          image={{alt:"ant",src:ant}} 
          title="Intern at Ant Financial" 
          subtitle="Sept. , 2018 - Dec. , 2018" 
          content={
            <div>
              <div>Dialog act classification</div>
              <div>Mentor: Jinhua Fu</div>
            </div>}
        />
        </AccordionDetails>
      </Accordion>);

    const papers = (        
      <Accordion
        defaultExpanded={true}
        >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='h4'>Publications</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <PaperEntry 
          image={{alt:"unimoco",src:unimoco}} 
          title="UniMoCo: Unsupervised, Semi-Supervised and Full-Supervised Visual Representation Learning" 
          subtitle={
            <div><b>Zhigang Dai</b>, Bolun Cai, Yugeng Lin, Junying Chen</div>}
          content={
            <div>
              <div>under review</div>
              <div><Link href="https://arxiv.org/abs/2103.10773">arXiv</Link><span className="space"></span> <Link href="https://github.com/dddzg/unimoco">code</Link></div>
            </div>}
        />
        <Divider variant="middle" />
        <PaperEntry 
          image={{alt:"up-detr",src:updetr}} 
          title="UP-DETR: Unsupervised Pre-training for Object Detection with Transformers" 
          subtitle={
            <div><b>Zhigang Dai</b>, Bolun Cai, Yugeng Lin, Junying Chen</div>}
          content={
            <div>
              <div>CVPR 2021, <b>Oral</b></div>
              <div><Link href="https://arxiv.org/pdf/2011.09094">arXiv</Link><span className="space"></span> <Link href="https://github.com/dddzg/up-detr">code/models</Link></div>
            </div>}
        />
        <Divider variant="middle" />
        <PaperEntry 
          image={{alt:"da",src:da}} 
          title="Local Contextual Attention with Hierarchical Structure for Dialogue Act Recognition" 
          subtitle={
            <div><b>Zhigang Dai</b>, Jinhua Fu, Qile Zhu, Hengbin Cui, Xiaolong Li, Yuan Qi</div>}
          content={
            <div>
              <div><Link href="https://arxiv.org/pdf/2003.06044">arXiv</Link></div>
            </div>}
        />
        </AccordionDetails>
      </Accordion>);
    const probjects = (        
      <Accordion
        defaultExpanded={true}
        >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant='h4'>Projects</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <Entry
          image={{alt:"wechat",src:wechat}} 
          title="WeChat QR Code Open Source" 
          subtitle={
            <Typography variant='h6'><div>Contribute WeChat QR code module to OpenCV.</div><div> WeChat QR code detector is a high-performance and lightweight QR code detect and decode library. It consists of a CNN-based QR code detector and a CNN-based QR code enhancement.</div></Typography>}
          content={
            <div>
              <div><Link href="https://github.com/opencv/opencv_contrib/tree/master/modules/wechat_qrcode">code (OpenCV)</Link></div>
            </div>}
        />
        <Divider variant="middle" />
        <PaperEntry
          image={{alt:"nl2sql",src:nl2sql}} 
          title="Natural Language to SQL Challenge"
          subtitle={
            <div>
              <div><b>Zhigang Dai</b>,<Link href="https://scholar.google.com/citations?user=ga0H1wYAAAAJ">Qile Zhu</Link></div>
              <div>Rank: <b>5</b>/1458</div>
            </div>
          }
          content={
            <div>
              Given the natural language (Chinese), the model need to convert it into SQL (struct query language).
              <div><Link href="https://github.com/dddzg/dddzg.github.io/raw/master/ppt/nl2sql.pptx">report</Link><span className="space"></span><Link href="https://tianchi.aliyun.com/competition/entrance/231716/introduction">website</Link></div>
            </div>}
        />
        <Divider variant="middle" />
        <Entry
          image={{alt:"ant",src:ant}} 
          title="Ant Financial: Natural Language Inference"
          subtitle={
            <div>
              <div><b>Zhigang Dai</b>, Dongming Sheng</div>
              <div>Rank: <b>4</b>/2632</div>
            </div>
          }
          content={
            <div>
              Given two natural language sentences, the model need to judge them whether sematic consistent.
              <div><Link href="https://github.com/dddzg/dddzg.github.io/raw/master/ppt/ant.pptx">report</Link><span className="space"></span><Link href="https://dc.cloud.alipay.com/index#/topic/intro?id=3">website</Link></div>
            </div>}
        />
        <Divider variant="middle" />
        <PaperEntry
          image={{alt:"zero_shot",src:zero_shot}} 
          title="Zero-shot Image Recognition"
          subtitle={
            <div>
              <div>Wenpeng Wei, <b>Zhigang Dai</b>, Sihao Chen</div>
              <div>Rank: <b>2</b>/3225</div>
            </div>
          }
          content={
            <div>
              Recognizing samples from classes that were not observed during training.
              <div><Link href="https://github.com/dddzg/dddzg.github.io/raw/master/ppt/zero-shot.pptx">report</Link><span className="space"></span><Link href="https://tianchi.aliyun.com/competition/entrance/231677/introduction">website</Link></div>
            </div>}
        />
        <Divider variant="middle" />
        <PaperEntry
          image={{alt:"mps",src:mps}} 
          title="Customized MapleStory (Game)"
          subtitle={
            <div>
              <div><b>Zhigang Dai</b></div>
            </div>
          }
          content={
            <div>
              MapleStory is a famous 2D, side-scrolling MMORPG (massively multiplayer online role-playing game), which I was addicted to in my elementary and junior school.
              <div>I make a customized MapleStory, which is writtern by C++ with <Link href="https://github.com/cocos2d/cocos2d-x">cocos2d engine</Link>.</div>
              <div><Link href="https://github.com/dddzg/MapleStory-cocos2d">code</Link></div>
            </div>}
        />
        </AccordionDetails>
      </Accordion>);
    return (
      <Container maxWidth="md" className="last_margin">
        <CssBaseline />
        {avator}
        {education}
        {experience}
        {papers}
        {probjects}
      </Container>
    );
  }
}

export default App;
